import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";
import { Formik, Form, FieldArray } from "formik";

import { Divider, PageHeader, Button, Col, Row } from "antd";
import { InputText, InputCheckbox } from "../../../../core/components/form";

import Papa from "papaparse";
import readXlsxFile from "read-excel-file";

import { Upload } from "antd";
import { UploadOutlined, CloudUploadOutlined } from "@ant-design/icons";

import mapValues from "lodash/mapValues";

/*
const LoginSchema = Yup.object().shape({
    words: Yup.lazy((obj) =>
        Yup.object(
            mapValues(obj, (value, key) => {
                return Yup.number().typeError("Must be a number").required("Cannot be blank.");
            })
        )
    ),
});*/

const LoginSchema = Yup.object()
    .shape({
        words: Yup.lazy((obj) =>
            Yup.object(
                mapValues(obj, (value, key) => {
                    return Yup.number().typeError("Must be a number").required("Cannot be blank.");
                })
            )
        ),
        wordCount: Yup.number().typeError("Must be a number").required("Cannot be blank."),
    })
    .test("sums", function (value) {
        if (!value) return true;
        const { words, wordCount } = value;
        const sum = Object.values(words).reduce((a, b) => a + b);
        let valid = false;
        if (sum == wordCount) {
            valid = true;
        }

        return (
            valid ||
            this.createError({
                // Formik will use the error "path" as the key in the errors; set this to whatever you want
                path: "wordCount",
                message: "The word count is not the sum of the words",
            })
        );
    });

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
};

/**
 *
 */
export default class Formulario extends React.Component {
    constructor() {
        super();
        this.state = {
            csvfile: undefined,
            fileList: [],
            uploading: false,
        };
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    _initialForm = () => {
        const { data } = this.props;

        let initalWords = {};

        if (data && data.values) {
            data.values.map((a) =>
                Object.defineProperty(initalWords, a.id, {
                    value: 0,
                    writable: true,
                    enumerable: true,
                    configurable: true,
                })
            );
        }

        if (data && data.task.receivables) {
            data.task.receivables.map((r) => {
                if (r.catlogValue) {
                    initalWords[r.catlogValue.id] = Number.parseInt(r.count);
                }
            });
        }

        if (data && data.timestamp) {
            return {
                wordCount: data.task.wordCount,
                words: initalWords,
                repetitions: data.task.repetitions,
                ICEMatches: data.task.ICEMatches,
                machineTranslation: data.task.machineRepetitions,
                matches100: data.task.matches100,
            };
        }
    };

    _onRemove = (setFieldValue) => (file) => {
        //setFieldValue('file', [{}]);
        this.setState((state) => {
            const index = state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            return {
                fileList: newFileList,
            };
        });
    };

    _stringToCatlogValue = (range) => {
        const { data } = this.props;

        if (range == "95_75_") {
            /* hardcode range */
            range = "95_85_";
        }

        for (const x of data.values) {
            if (x.key == range) {
                return x.id;
            }
        }

        return null;
    };

    _beforeUpload = (setFieldValue) => (file) => {
        Papa.parse(file, {
            complete: (result) => {
                const total = result.data.length - 1;
                const line = result.data[total];
                Object.keys(line).forEach((el, key, o) => {
                    const id = this._stringToCatlogValue(el);

                    if (id) {
                        setFieldValue("words." + id, line[el]);
                    }
                    /*
                    if (typeof this.props.data.base_words[el] !== 'undefined') {
                        setFieldValue("words." + el,line[el])
                    }
                    */
                });

                //setFieldValue('file', [result.data[total]]);
                setFieldValue("wordCount", result.data[total].total);
            },
            skipEmptyLines: true,
            transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
            header: true,
        });

        this.setState((state) => ({
            fileList: [file],
        }));
        return false;
    };

    render() {
        const { fileList } = this.state;

        return (
            <>
                <div className="site-page-header-ghost-wrapper">
                    <PageHeader ghost={false} onBack={this._goBack} title="Receivable CSV" subTitle="FORM">
                        <Formik
                            initialValues={this._initialForm()}
                            validationSchema={LoginSchema}
                            onSubmit={this.props.handleSubmit}
                        >
                            {({ isSubmitting, touched, errors, setFieldValue, values }) => (
                                <Form>
                                    <Row>
                                        <Col span={16} offset={4}>
                                            <Divider orientation="left" plain>
                                                Settings
                                            </Divider>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} offset={4}>
                                            <InputCheckbox
                                                name="ICEMatches"
                                                label="ICE Matches"
                                                errors={errors.ICEMatches}
                                                touched={touched.ICEMatches}
                                                layout="horizontal"
                                            />
                                            <InputCheckbox
                                                name="matches100"
                                                label="100% Matches"
                                                errors={errors.matches100}
                                                touched={touched.matches100}
                                                layout="horizontal"
                                            />

                                            <InputCheckbox
                                                name="repetitions"
                                                label="Repetitions"
                                                errors={errors.repetitions}
                                                touched={touched.repetitions}
                                                layout="horizontal"
                                            />

                                            <InputCheckbox
                                                name="machineTranslation"
                                                label="Machine Translation"
                                                errors={errors.machineTranslation}
                                                touched={touched.machineTranslation}
                                                layout="horizontal"
                                            />
                                        </Col>

                                        <Col span={8}>
                                            <Upload
                                                fileList={fileList}
                                                beforeUpload={this._beforeUpload(setFieldValue)}
                                                onRemove={this._onRemove(setFieldValue)}
                                            >
                                                <Button>
                                                    <UploadOutlined /> Select File
                                                </Button>
                                            </Upload>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={16} offset={4}>
                                            <Divider plain />
                                        </Col>
                                    </Row>

                                    <FieldArray name="words">
                                        <>
                                            {this.props.data.values.map((cv) => {
                                                const e = errors.words ? errors.words : undefined;
                                                const t = touched.words ? touched.words : undefined;

                                                return (
                                                    <InputText
                                                        name={`words.${cv.id}`}
                                                        key={cv.id}
                                                        label={cv.name}
                                                        errors={e ? e[cv.id] : undefined}
                                                        touched={t ? t[cv.id] : undefined}
                                                        placeholder=""
                                                        layout="horizontal"
                                                        formItemLayout={formItemLayout}
                                                        required
                                                    />
                                                );
                                            })}
                                        </>
                                    </FieldArray>
                                    <InputText
                                        name="wordCount"
                                        label="WC"
                                        placeholder="WC"
                                        errors={errors.wordCount}
                                        touched={touched.wordCount}
                                        layout="horizontal"
                                        formItemLayout={formItemLayout}
                                        required
                                    />

                                    <Divider plain />

                                    <Row>
                                        <Col span={16} offset={4}>
                                            <button
                                                onClick={this._goBack}
                                                type="button"
                                                className="ant-btn ant-btn-default"
                                            >
                                                <i className="fa fa-arrow-left"></i>
                                                <Divider type="vertical" />
                                                Cancel
                                            </button>
                                            <div className="pull-right">
                                                <button
                                                    type="submit"
                                                    className="ant-btn ant-btn-primary"
                                                    disabled={isSubmitting}
                                                >
                                                    <CloudUploadOutlined />
                                                    <Divider type="vertical" />
                                                    {isSubmitting ? "One moment ..." : "Save"}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    </PageHeader>
                </div>
            </>
        );
    }
}
